import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchSimilarCars } from "../car-details/actions";
import { reloadCarList, resetCarList } from "../car-listing/actions";
import { clearAllFilters, updateAppliedFilters, updateSelectedOnScreenFilter } from "../filters/actions";
import MoreCarsForYouRevamp from "./component";

const mapStateToProps = ({
    carDetails: {content, config},
    filters: {allFilters}
}) => ({
    content,
    allFilters,
    config
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    resetCarListConnect: resetCarList,
    reloadCarListConnect: reloadCarList,
    updateSelectedOnScreenFilterConnect: updateSelectedOnScreenFilter,
    updateAppliedFiltersConnect: updateAppliedFilters,
    clearAllFiltersConnect: clearAllFilters,
    fetchSimilarCarsConnect: fetchSimilarCars
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MoreCarsForYouRevamp);
